import util from './util'
import GenericList from './component-list'

let Author = Vue.component('author', {
	props: ['body', 'posts', 'name'],
	data() {
		return {
			data: [],
			pushFix: true
		}
	},
	methods: {
		onClick: util.onClickDefaultLink
	},
	template: `
		<div>
			<div v-html="body"></div>
			<acf-posts :posts="posts" :headline="'Texts by ' + name"></acf-posts>
		</div>`
})

export default Author
